import { render } from "./ErrorPage.vue?vue&type=template&id=18f6bf43&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"

import "./ErrorPage.vue?vue&type=style&index=0&id=18f6bf43&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/icatorfe-svts-multi_release_1_16/sourceCode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f6bf43"],['__file',"src/pages/ErrorPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18f6bf43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18f6bf43', __exports__)) {
    console.log('reload')
    api.reload('18f6bf43', __exports__)
  }
  
  module.hot.accept("./ErrorPage.vue?vue&type=template&id=18f6bf43&scoped=true", () => {
    console.log('re-render')
    api.rerender('18f6bf43', render)
  })

}


export default __exports__